import { render, staticRenderFns } from "./HospitalPopup.vue?vue&type=template&id=4535e28b"
import script from "./HospitalPopup.vue?vue&type=script&lang=js"
export * from "./HospitalPopup.vue?vue&type=script&lang=js"
import style0 from "./HospitalPopup.vue?vue&type=style&index=0&id=4535e28b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports